import stateClass, {CHANGE_EVENT} from '../baseState';
import {SchoolTypesState, RAW_DATA_UPDATE_EVENT} from '../schoolTypes/state';
import {alphabetArray} from '../config';

const TEXT_ALL_MUNICIP = 'VISAS PAŠVALDĪBAS';

class MunicipClass extends stateClass{

	constructor(){

		super();

		SchoolTypesState.on(RAW_DATA_UPDATE_EVENT, () => {

			this.update(this.getMunicipalities());
		});
	}

	getMunicipalities() {

		var municipalities = [];

		var rawdata = SchoolTypesState.getRawData();

		if(typeof rawdata.features === 'undefined') {
			return [];
		}

		for (var i = rawdata.features.length - 1; i >= 0; i--) {

			var municip = rawdata.features[i].properties.Pasvaldiba;

			if(municipalities.indexOf(municip) === -1) {
				municipalities.push(municip);
			}
		}

		console.log('getMunicipalities municipalities', municipalities[0]);

		var sortComparer = function(a, b) {
			  // are the strings equal?
				if(a === b) {
					return 0;
				}

			  // if they are not equal, compare the first letters
			  //  against the custom sort order
			  var indexOfA = alphabetArray.indexOf(a[0].toLocaleLowerCase());
			  var aInList = indexOfA >= 0;

			  var indexOfB = alphabetArray.indexOf(b[0].toLocaleLowerCase());
			  var bInList = indexOfB >= 0;

			  // if the first letter of neither string is in the list,
			  //  compare alphabetically
			  if(!aInList && !bInList) {
			    return a.localeCompare(b);
			  } else if(!aInList) {
			    // the first letter of only a is not in the list
			    return 1;
			  } else if(!bInList) { 
			    // the first letter of only b is not in the list
			    return -1;
			  } else if(indexOfA === indexOfB) {
			    // the first letter of a and b are both in the list
			    //  and they are the same
			    return a.localeCompare(b);
			  } else {
			    // the first letters are different; sort by first letter
			    return indexOfA - indexOfB;
			  }
		};

		municipalities.sort(sortComparer);

		console.log('getMunicipalities municipalities 2', municipalities[0]);
		municipalities.unshift(TEXT_ALL_MUNICIP);

		return municipalities;
	}
}

var MunicipalitiesState = new MunicipClass;

export {MunicipalitiesState, CHANGE_EVENT, TEXT_ALL_MUNICIP}


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/municipalities/state.js